import { getStaticUrl } from '~/utils/static'

export default (_context: any, inject: any) => {
  inject('s', getStaticUrl)
}
